/* import config data */
import config from './config.json'

/* import lib from vue */
import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import VueProgressBar from 'vue-progressbar'
import BootstrapVue from 'bootstrap-vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import VueSwal from 'vue-sweetalert2'
import VueClazyLoad from 'vue-clazy-load'
import VModal from 'vue-js-modal'
import moment from 'moment'
moment.locale('en');

import intersection from 'intersection-observer'


/* import css */
import 'bootstrap/dist/css/bootstrap.css'

/* import components */
import dashboard from './components/dashboard.vue'
import teams from './components/teams.vue'
import teamsOnline from './components/teamsOnline.vue'

import teamsView from './components/teamsView.vue'
import issuesView from './components/issuesView.vue'

Vue.config.productionTip = false

Vue.use(BootstrapVue);
Vue.use(intersection);

Vue.use(VueProgressBar, config.progressBar)
Vue.use(VueRouter)
Vue.use(VueGoogleMaps, config.googleMaps)
Vue.component('GmapCluster', GmapCluster)
Vue.use(VueSwal)
Vue.use(VueClazyLoad)
Vue.use(VModal, {
  dialog: true,
  injectModalsContainer: true
})


const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [{
      path: '/',
      component: dashboard
    },
    {
      path: '/teams',
      component: teams
    },
    {
      path: '/online',
      component: teamsOnline
    },
    {
      path: '/teams/:id',
      component: teamsView
    },
    {
      path: '/issues',
      component: issuesView
    }
  ]
})
router.beforeEach((to, from, next) => {
  document.title = "RaceView - podgląd wyścigu online..."
  next()
})


Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('DD.MM.YYYY hh:mm')
  }
})

Vue.filter('formatDateCorrect', function(value) {
  if (value) {
    return moment(value).utcOffset(value).format("DD.MM.YYYY HH:mm")
  }
})

Vue.filter('ago', function(value) {
  if (value) {
    return moment(String(value)).fromNow()
  }
})



new Vue({
  el: '#app',
  router,
  render: h => h(App)
})
